export default function PatientFlowDiagram() {
    return (
        <div className="w-full bg-gradient-to-br from-slate-50 via-white to-gray-50">
            <svg viewBox="0 0 1000 650" className="w-full h-auto">
                <defs>
                    <marker id="arrowGray" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#9ca3af" />
                    </marker>
                    <marker id="arrowGreen" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#22c55e" />
                    </marker>
                    <marker id="arrowBlue" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#2CABCC" />
                    </marker>
                </defs>

                {/* QR Code Scanning */}
                <rect x="30" y="260" width="120" height="40" rx="8" fill="#fbbf24" />
                <text x="90" y="285" textAnchor="middle" fontSize="11" fontWeight="600" fill="#1f2937">QR Code Scanning</text>
                <text x="30" y="245" fontSize="9" fill="#6b7280">Every Clinic/Hospital will have their</text>
                <text x="30" y="255" fontSize="9" fill="#6b7280">own unique QR Code</text>

                {/* QR to Clinic Line */}
                <line x1="150" y1="280" x2="190" y2="280" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Clinic/Hospital Page */}
                <rect x="200" y="260" width="140" height="40" rx="8" fill="#2CABCC" />
                <text x="270" y="285" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Clinic/Hospital Page</text>
                <text x="200" y="250" fontSize="9" fill="#6b7280">Clinic/Hospital Detail</text>

                {/* Clinic to BP APIs Line */}
                <line x1="340" y1="280" x2="480" y2="280" stroke="#9ca3af" strokeWidth="2" />
                <text x="400" y="270" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* BP APIs */}
                <rect x="490" y="250" width="80" height="60" rx="8" fill="#ef4444" />
                <text x="530" y="285" textAnchor="middle" fontSize="12" fontWeight="700" fill="white">BP APIs</text>

                {/* Line from Clinic up to New Patient */}
                <path d="M 270 260 L 270 100 L 330 100" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />
                <text x="220" y="180" fontSize="9" fill="#22c55e" fontWeight="500">If patient is new</text>

                {/* New Patient */}
                <rect x="340" y="80" width="110" height="40" rx="8" fill="#22c55e" />
                <text x="395" y="105" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">New Patient</text>

                {/* New Patient to Onboarding Form */}
                <line x1="450" y1="100" x2="490" y2="100" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Onboarding Form */}
                <rect x="500" y="80" width="120" height="40" rx="8" fill="#f97316" />
                <text x="560" y="105" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Onboarding Form</text>

                {/* Onboarding Form Info */}
                <text x="500" y="30" fontSize="8" fill="#6b7280">Onboarding Form:</text>
                <text x="500" y="40" fontSize="8" fill="#6b7280">1. Personal Information</text>
                <text x="500" y="50" fontSize="8" fill="#6b7280">2. Medical Information</text>
                <text x="500" y="60" fontSize="8" fill="#6b7280">3. Insurance Details</text>
                <text x="590" y="40" fontSize="8" fill="#6b7280">4. Preferences</text>
                <text x="590" y="50" fontSize="8" fill="#6b7280">5. Document Upload</text>
                <text x="590" y="60" fontSize="8" fill="#6b7280">6. Consent &amp; Privacy</text>

                {/* Onboarding Form to BP APIs (down) */}
                <line x1="560" y1="120" x2="560" y2="180" stroke="#9ca3af" strokeWidth="2" />
                <path d="M 560 180 L 530 180 L 530 250" fill="none" stroke="#9ca3af" strokeWidth="2" />
                <text x="565" y="155" fontSize="9" fill="#6b7280" fontWeight="500">WRITE</text>

                {/* Onboarding Form to Appointment Booking */}
                <line x1="620" y1="100" x2="680" y2="100" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Appointment Booking */}
                <rect x="690" y="80" width="130" height="40" rx="8" fill="#a855f7" />
                <text x="755" y="105" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Appointment Booking</text>
                <text x="690" y="30" fontSize="8" fill="#6b7280">Choose practitioner, available slots, give</text>
                <text x="690" y="40" fontSize="8" fill="#6b7280">reasons to visit and book appointment.</text>

                {/* Appointment Booking to Appointment Booked */}
                <line x1="820" y1="100" x2="860" y2="100" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Appointment Booked */}
                <rect x="870" y="80" width="120" height="40" rx="8" fill="white" stroke="#9ca3af" strokeWidth="2" />
                <text x="930" y="105" textAnchor="middle" fontSize="11" fontWeight="600" fill="#1f2937">Appointment Booked</text>

                {/* Line from Clinic down to Existing Patient */}
                <path d="M 270 300 L 270 480 L 330 480" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />
                <text x="150" y="430" fontSize="9" fill="#6b7280" fontWeight="500">If patient already visited the clinic</text>

                {/* Existing Patient */}
                <rect x="340" y="460" width="120" height="40" rx="8" fill="#22c55e" />
                <text x="400" y="485" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Existing Patient</text>

                {/* Existing Patient to Patient Login */}
                <line x1="460" y1="480" x2="500" y2="480" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Patient Login */}
                <rect x="510" y="460" width="110" height="40" rx="8" fill="#a855f7" />
                <text x="565" y="485" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Patient Login</text>
                <text x="510" y="515" fontSize="8" fill="#6b7280">Patient can login with the following instructions,</text>
                <text x="510" y="525" fontSize="8" fill="#6b7280">1. Medicare Card Number</text>
                <text x="510" y="535" fontSize="8" fill="#6b7280">Or</text>
                <text x="510" y="545" fontSize="8" fill="#6b7280">2. Phone Number</text>

                {/* Patient Login to BP APIs (up) */}
                <line x1="565" y1="460" x2="565" y2="380" stroke="#9ca3af" strokeWidth="2" />
                <path d="M 565 380 L 530 380 L 530 310" fill="none" stroke="#9ca3af" strokeWidth="2" />
                <text x="540" y="400" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>
                <text x="540" y="360" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* Patient Login to Patient Portal */}
                <line x1="620" y1="480" x2="680" y2="480" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray)" />

                {/* Patient Portal */}
                <rect x="690" y="460" width="110" height="40" rx="8" fill="#2CABCC" />
                <text x="745" y="485" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Patient Portal</text>

                {/* Patient Portal to BP APIs (WRITE) */}
                <path d="M 745 460 L 745 340 L 570 340 L 570 310" fill="none" stroke="#9ca3af" strokeWidth="2" />
                <text x="650" y="330" fontSize="9" fill="#6b7280" fontWeight="500">WRITE</text>

                {/* Patient Portal to Upcoming Appointments */}
                <path d="M 800 470 L 860 470 L 860 400" fill="none" stroke="#22c55e" strokeWidth="2" markerEnd="url(#arrowGreen)" />
                <text x="810" y="430" fontSize="8" fill="#6b7280">If patient have some upcoming appointments</text>

                {/* Upcoming Appointments */}
                <rect x="820" y="350" width="100" height="45" rx="8" fill="#2CABCC" />
                <text x="870" y="370" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Upcoming</text>
                <text x="870" y="382" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Appointments</text>

                {/* Patient Portal to Checkin/out */}
                <path d="M 745 500 L 745 580 L 820 580" fill="none" stroke="#22c55e" strokeWidth="2" markerEnd="url(#arrowGreen)" />

                {/* Checkin/out */}
                <rect x="830" y="560" width="100" height="40" rx="8" fill="#2CABCC" />
                <text x="880" y="585" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Checkin/out</text>
                <text x="740" y="620" fontSize="8" fill="#6b7280">Patient can check in out from the portal where timer of the</text>
                <text x="740" y="630" fontSize="8" fill="#6b7280">clinic presence will be shown. So, that practitioner or clinic</text>
                <text x="740" y="640" fontSize="8" fill="#6b7280">can easily see that if patient is present.</text>

                {/* Legend */}
                <rect x="30" y="590" width="12" height="12" rx="2" fill="#fbbf24" />
                <text x="48" y="600" fontSize="9" fill="#6b7280">Entry Point</text>

                <rect x="120" y="590" width="12" height="12" rx="2" fill="#22c55e" />
                <text x="138" y="600" fontSize="9" fill="#6b7280">Patient Type</text>

                <rect x="210" y="590" width="12" height="12" rx="2" fill="#f97316" />
                <text x="228" y="600" fontSize="9" fill="#6b7280">Form</text>

                <rect x="270" y="590" width="12" height="12" rx="2" fill="#a855f7" />
                <text x="288" y="600" fontSize="9" fill="#6b7280">Action</text>

                <rect x="340" y="590" width="12" height="12" rx="2" fill="#2CABCC" />
                <text x="358" y="600" fontSize="9" fill="#6b7280">Portal</text>

                <rect x="410" y="590" width="12" height="12" rx="2" fill="#ef4444" />
                <text x="428" y="600" fontSize="9" fill="#6b7280">API</text>
            </svg>
        </div>
    );
}